export default "__VITE_ASSET__df60e979__"